import { render, staticRenderFns } from "./ProcessDesign.vue?vue&type=template&id=47995055&scoped=true"
import script from "./ProcessDesign.vue?vue&type=script&lang=js"
export * from "./ProcessDesign.vue?vue&type=script&lang=js"
import style0 from "./ProcessDesign.vue?vue&type=style&index=0&id=47995055&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47995055",
  null
  
)

export default component.exports